import type { Resource } from '../../';
export const cart_cartItem_each: Resource = {"default":"Each"};
